import { useEffect, useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { api, fmt } from "../../lib/api";
import { isLow } from "../shared";
import { Stat, usePolicy } from "./common";

export default function FactSheetMovementTab({ it, onAdjust }) {
  const [txs, setTxs] = useState(null);
  const pol = usePolicy(it);
  useEffect(() => { api.get("/transactions", { params: { item_id: it.id, limit: 25 } }).then((r) => setTxs(r.data)); }, [it.id, it.stock]);
  const oo = it.on_order_qty || 0;
  const buffer = it.stock - it.par_level;
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-2 gap-3">
        <Stat label="ON HAND" value={it.stock} unit={it.unit} cls={isLow(it) ? "text-[#F59E0B]" : ""} testId="fact-on-hand" />
        <Stat label="ON ORDER" value={oo} unit={it.unit} cls="text-[#38BDF8]" testId="fact-on-order" />
        <Stat label="PROJECTED" value={it.stock + oo} unit={it.unit} testId="fact-projected" />
        <Stat label="SAFETY BUFFER (VS PAR)" value={buffer} unit={it.unit} cls={buffer < 0 ? "text-[#EF4444]" : "text-[#10B981]"} testId="fact-buffer" />
        <div className="col-span-2 p-3 rounded-md bg-[#090D16] border border-[#38BDF8]/40 flex items-center justify-between" data-testid="fact-adcr" data-tip="Average Daily Consumption Rate over the item's ADCR window">
          <span className="font-mono text-[10px] tracking-[0.2em] text-[#6B7280]">ADCR{pol ? ` · ${pol.adcr_window_days}D WINDOW` : ""}</span>
          <span className="font-mono font-bold text-[#38BDF8]" data-testid="fact-adcr-value">{it.inactive ? "INACTIVE" : pol ? `${fmt(pol.adcr)} ${it.unit}/day` : "…"}</span>
        </div>
      </div>
      <button data-testid="fact-adjust-btn" onClick={onAdjust} className="h-12 w-full rounded-md border border-[#334155] font-semibold flex items-center justify-center gap-2 hover:border-[#F59E0B]"><SlidersHorizontal className="w-4 h-4" />Receive / Ship / Adjust</button>
      <div>
        <div className="font-mono text-[10px] tracking-[0.2em] text-[#6B7280] mb-2">RECENT MOVEMENT</div>
        <div className="border border-[#1E293B] rounded-md divide-y divide-[#1E293B]" data-testid="fact-tx-log">
          {(txs || []).map((t) => (
            <div key={t.id} className="flex justify-between gap-3 px-3 py-2 text-xs">
              <div className="min-w-0"><div className="font-mono uppercase font-bold text-[#9CA3AF]">{t.type}</div><div className="text-[#6B7280] truncate">{new Date(t.timestamp).toLocaleString()} · {t.note}</div></div>
              <div className={`font-mono font-bold shrink-0 ${t.qty_change < 0 ? "text-[#EF4444]" : "text-[#10B981]"}`}>{t.qty_change > 0 ? "+" : ""}{fmt(t.qty_change)}</div>
            </div>
          ))}
          {txs && !txs.length && <div className="px-3 py-4 text-xs text-[#6B7280]">No transactions yet.</div>}
        </div>
      </div>
    </div>
  );
}
